import axios from "axios";
import services from "@/config/services";

export default class SyncService {

    constructor (eventBus) {
        this.eventBus = eventBus;
        this.baseUrlFlussi = `${services.ask_flussi_api.url}`;
    }

    async getSyncTable(group_id=null) {
        const url = `${this.baseUrlFlussi}/get_sync_table`;
        if(group_id) {
            try {
                let res = await axios.get(`${url}/${group_id}`);
                return res.data;
            } catch(err) {
                this.eventBus.emit("data-load-error", { message: err, url });
            }
        } else {
            try {
                let res = await axios.get(url);
                return res.data;
            } catch(err) {
                this.eventBus.emit("data-load-error", { message: err, url });
            }
        }
    }

    async getSyncLogs() {
        const url = `${this.baseUrlFlussi}/get_sync_logs`;

        try {
            let res = await axios.get(url);
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

    async getSyncGroupDate() {
        const url = `${this.baseUrlFlussi}/get_sync_logs_group_date`;

        try {
            let res = await axios.get(url);
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

    async getSyncLogsByGroupId(groupId) {
        const url = `${this.baseUrlFlussi}/get_sync_logs_group?group_id=${groupId}`;

        try {
            let res = await axios.get(url);
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

    async getSyncLogsDetails(id) {
        const url = `${this.baseUrlFlussi}/get_sync_logs_details?id=${id}`;

        try {
            let res = await axios.get(url);
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

    async updateSyncTable(updatedRecord) {
        const UpdateURL = `${this.baseUrlFlussi}/update_sync_table`;

        try {
            let record = { 
                id: updatedRecord.id,
                source_db_id: updatedRecord.source_db_id.id,
                destination_db_id: updatedRecord.destination_db_id.id,
                table_name: updatedRecord.table_name,
                type: updatedRecord.type,
                group_id: updatedRecord.group_id,
                orderID: updatedRecord.orderID, 
            };
            let res = await axios.post(UpdateURL, record);
            if(res.data.message) {
                this.eventBus.emit("data-load-success", {message: res.data.message, url: UpdateURL});
            } else {
                this.eventBus.emit("data-load-error", { message: "Nessuna modifica.", url: UpdateURL });
            }
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, UpdateURL });
        }
    }

    async saveSyncTable(updatedRecord) {
        const saveURL = `${this.baseUrlFlussi}/save_sync_table`;

        try {
            let record = { 
                // id: updatedRecord.id,
                source_db_id: updatedRecord.source_db_id.id,
                destination_db_id: updatedRecord.destination_db_id.id,
                table_name: updatedRecord.table_name,
                type: updatedRecord.type,
                group_id: updatedRecord.group_id,
                orderID: updatedRecord.orderID,
            };
            let res = await axios.post(saveURL, record);
            if(res.data.message) {
                this.eventBus.emit("data-load-success", {message: res.data.message, url: saveURL});
            } else {
                this.eventBus.emit("data-load-error", { message: "Nessuna modifica.", url: saveURL });
            }
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, saveURL });
        }
    }

    async getDatabaseDetails() {
        const url = `${this.baseUrlFlussi}/get_db_det`;

        try {
            let res = await axios.get(url);
            if(res.data) {
                return res.data;
            }
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

    async eliminaGruppo(gruppo) {
        const url = `${this.baseUrlFlussi}/elimina_gruppo/${gruppo}`;

        try {
            let res = await axios.delete(url);
            if(res.data) {
                this.eventBus.emit("data-load-success", {message: "Eliminazione completata", url: url});
                return res.data;
            }
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

    async eliminaTabellaGruppo(gruppo, tab) {
        const url = `${this.baseUrlFlussi}/elimina_tabella_gruppo/${gruppo}/${tab}`;

        try {
            let res = await axios.delete(url);
            if(res.data) {
                this.eventBus.emit("data-load-success", {message: "Eliminazione completata", url: url});
                return res.data;
            }
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
        }
    }

}


